/*
Para animar elementos en la página con animate css

https://github.com/animate-css/animate.css/blob/main/docsSource/sections/04-javascript.md
*/
// prefix = 'animate__' creo que es de la nueva versión de animate.css en la nuestra es sin prefijo
// eslint-disable-next-line import/prefer-default-export
export function animateCSS(element, animation, prefix = '') {
  // We create a Promise and return it
  return new Promise((resolve, _reject) => {
    const animationName = `${prefix}${animation}`;
    let node = element;
    if (!(element instanceof Element)) {
      node = document.querySelector(element);
    }

    node.classList.add(`${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(`${prefix}animated`, animationName);
      resolve('Animation ended');
    }

    node.addEventListener('animationend', handleAnimationEnd, { once: true });
  });
}

/**
 * Hay que usar este método para asegurarnos de que empiece la animación,
 * pintado de clases etc. antes de hacer un proceso pesado
 * https://stackoverflow.com/questions/44145740/how-does-double-requestanimationframe-work
 */
export function doubleRaf(callback) {
  requestAnimationFrame(() => requestAnimationFrame(callback));
}
